import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import ModalAddProduct from './modal/productmodal.vue'

import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'

export default {
  name: 'CrmDetailsProduct',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    boardArchived: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: null,
      form: null,
      products: null,
      hasProducts: false
    }
  },
  components: {
    ModalAddProduct
  },
  computed: {
    totalValue () {
      let result = null
      if (this.objList && this.objList.length > 0) {
        this.objList.forEach(element => {
          result += element.valor
        })
      }
      return result
    }
  },
  watch: {
    card () {
      if (this.card) {
        this.onLoadAllProducts()
      }
    }
  },
  methods: {
    onLoad () {
      this.onLoadAllProducts()
    },
    onLoadAllProducts () {
      if (this.card) {
        CardProductRepository.Search(this.card.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.hasProducts = response.data.content.length > 0
            this.onResultGrid(response)
          })
          .catch(this.onException)
      }
    },
    onAddProduct () {
      this.$refs.ModalAddProduct.showModal()
    },
    onReload () {
      this.onLoadAllProducts()
      this.$emit('Reload')
    },
    onDelete (obj) {
      CardProductRepository.Delete(obj.id)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_excluido', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi excluído!', this.ip, this.latitude, this.longitude, this.card.id)
            this.onReload()
          }
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      if (!this.boardArchived) this.$refs.ModalAddProduct.showModal(obj)
    },
    formatValue (value) {
      return Tools.formatMoneyBR(value)
    },
    checkTypeBoard (card) {
      if (card && card.boardColumn.board.tipoBoard === 'COBRANCA') {
        return true
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/product/product.js